(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["banners-carousel"] && !Shopify.designMode) return;
  try {
    
jQuery(function() {
  jQuery('.banners-carousel-section').each(function() {
    var $section = jQuery(this);
    var $slider = $section.find('.banners-carousel');

    var autoplay = String($section.attr('data-autoplay')) === 'true';
    var autoplaySpeed = parseInt($section.attr('data-autoplay-speed'), 10) || 3000;
    var transitionSpeed = parseInt($section.attr('data-transition-speed'), 10) || 300;

    if (!$slider.hasClass('slick-initialized')) {
      $slider.slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        rows: 0,
        prevArrow: '<button type="button" class="slick-prev">Previous</button>',
        nextArrow: '<button type="button" class="slick-next">Next</button>',
        infinite: false,
        autoplay: autoplay,
        autoplaySpeed: autoplaySpeed,
        speed: transitionSpeed,
        adaptiveHeight: false
      });
    }
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cookie-bar"]) return;
  try {
    

;(function() {
  const popup = jQuery('.js-cookies_popup');
  const openedClass = 'opened';
  const bodyOpenedClass = 'cookies-popup-opened';
  const closeBtn = popup.find('.js-cookies_close');
  const body = jQuery('body');

  closeBtn.on('click', function(e) {
    e.preventDefault();
    jQuery.cookie('cookies_popup_disabled', '1');
    hidePopup();
  });

  if (jQuery.cookie('cookies_popup_disabled') !== '1') {
    setTimeout(function() {
      if (popup.length) {
        showPopup();
      }
    }, popup.data('delay'));
  }

  function showPopup() {
    popup.addClass(openedClass);
    body.addClass(bodyOpenedClass);
  }

  function hidePopup() {
    popup.removeClass(openedClass);
    body.removeClass(bodyOpenedClass);
  }
}());


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-collection"] && !Shopify.designMode) return;
  try {
    
  $(function() {
    let $slider = $('.featured-collection-slider');

    $slider.slick({
      slidesToScroll: 1,
      rows: 0,
      arrows: false,
      dots: true,
      dotsClass: 'slick-dots',
      vertical: true,
      autoplay: true,
      autoplaySpeed: 5000,
      verticalSwiping: true,
      adaptiveHeight: true,
      responsive: [{
        breakpoint: 768,
        settings: {
          vertical: false,
          verticalSwiping: false,
        }
      }]
    });

  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-mobile"] && !Shopify.designMode) return;
  try {
    
jQuery(function() {
  jQuery('.bg-video').backgroundVideo({
    activeClass: 'video-active'
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero"] && !Shopify.designMode) return;
  try {
    
jQuery(function() {
  jQuery('.bg-video').backgroundVideo({
    activeClass: 'video-active'
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["newsletter-popup"]) return;
  try {
    
;(function() {
  const popup = jQuery('.js-newsletter_popup');
  const openedClass = 'opened';
  const bodyOpenedClass = 'newsletter-popup-opened';
  const control = jQuery('.js-newsletter-popup__form');
  const closeBtn = popup.find('.js-newsletter_close');
  const body = jQuery('body');

  closeBtn.on('click touchend', function(e) {
      e.preventDefault();
      if (jQuery(this).hasClass('newsletter-popup__close')) {
        jQuery.cookie('newsletter_popup_disabled', '1');
      }
      hidePopup();
  });

  if (jQuery.cookie('newsletter_popup_disabled') !== '1') {
    setTimeout(function() {
      if (popup.length) {
      showPopup();

      controlCookie();

      jQuery(document).on('click',function (e) {
        if(popup.hasClass(openedClass)) {
          if (!jQuery(e.target).closest(popup).length) {
            hidePopup();
          }
        }
      });
    }
    }, popup.data('delay'));
  }

  function showPopup() {
    popup.addClass(openedClass);
    body.addClass(bodyOpenedClass);
  }

  function hidePopup() {
    popup.removeClass(openedClass);
    body.removeClass(bodyOpenedClass);
  }

  function controlCookie() {
    control.on('submit', function(e) {
        e.preventDefault();
        let inputVal = control.find('.newsletter-popup__input').val();
        control.find('.newsletter-popup__row').removeClass('newsletter-popup__error');

        if (inputVal == '' || ! new RegExp('^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$').test(inputVal)) {
            control.find('.newsletter-popup__row').addClass('newsletter-popup__error');
            return false;
        }

        jQuery.ajax({
            url: control.attr('action'),
            method: control.attr('method'),
            success: function(data) {
                console.log(data);
                jQuery('.newsletter-popup__thankyou').removeClass('hide');
                jQuery('.newsletter-popup__main').addClass('hide');
            }

        });

        jQuery.cookie('newsletter_popup_disabled', '1');

    });
  }

}());

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-bracelets"]) return;
  try {
    
jQuery('.product-meta').slideAccordion({
  opener: '.product-meta__opener',
  slider: '.product-meta__content',
  animSpeed: 300,
  scrollToActiveItem: {
    enable: true,
    extraOffset: 57
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-earrings"]) return;
  try {
    
jQuery('.product-meta').slideAccordion({
  opener: '.product-meta__opener',
  slider: '.product-meta__content',
  animSpeed: 300,
  scrollToActiveItem: {
    enable: true,
    extraOffset: 57
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-lab"]) return;
  try {
    
jQuery('.product-meta').slideAccordion({
  opener: '.product-meta__opener',
  slider: '.product-meta__content',
  animSpeed: 300,
  scrollToActiveItem: {
    enable: true,
    extraOffset: 57
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-necklaces"]) return;
  try {
    
jQuery('.product-meta').slideAccordion({
  opener: '.product-meta__opener',
  slider: '.product-meta__content',
  animSpeed: 300,
  scrollToActiveItem: {
    enable: true,
    extraOffset: 57
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
var loadProductRecommendationsIntoSection = function() {
  // Look for an element with class 'product-recommendations'
  var productRecommendationsSection = document.querySelector(".product-recommendations");
  if (productRecommendationsSection === null) {
    return;
  }
  // Read request URL
  var requestUrl = productRecommendationsSection.dataset.url;

  // Create request and submit it using Ajax
  var request = new XMLHttpRequest();
  request.open("GET", requestUrl);
  request.onload = function() {
    if (request.status >= 200 && request.status < 300) {
      var container = document.createElement("div");
      container.innerHTML = request.response;
      var slides = container.querySelectorAll('.products-list__slide');

      if (slides.length !== 0 && slides.length !== undefined) {
        productRecommendationsSection.parentElement.innerHTML = container.querySelector(".product-recommendations").innerHTML;

        initProductsSlider();
      } else {
        productRecommendationsSection.closest('.products-list--related').remove();
      }
    }
  };
  request.send();
};

function initProductsSlider() {
  jQuery('.products-list__slider').slick({
    slidesToScroll: 1,
    slidesToShow: 4,
    rows: 0,
    prevArrow: '<button class="slick-prev"><span>Previous</span></button>',
    nextArrow: '<button class="slick-next"><span>Next</span></button>',
    infinite: true,
    autoplay: true,
    responsive: [{
      breakpoint: 1024,
        settings: {
          slidesToShow: 3
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2
        }
    }]
  });
}

// Listen for changes done in the Theme Editor
document.addEventListener("shopify:section:load", function(event) {
  if (event.detail.sectionId === "product-recommendations") {
    loadProductRecommendationsIntoSection();
  }
});

// Fetching the recommendations on page load
loadProductRecommendationsIntoSection();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-rings"]) return;
  try {
    
jQuery('.product-meta').slideAccordion({
  opener: '.product-meta__opener',
  slider: '.product-meta__content',
  animSpeed: 300,
  scrollToActiveItem: {
    enable: true,
    extraOffset: 57
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
jQuery('.product-meta').slideAccordion({
  opener: '.product-meta__opener',
  slider: '.product-meta__content',
  animSpeed: 300,
  scrollToActiveItem: {
    enable: true,
    extraOffset: 57
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["slideshow-new"] && !Shopify.designMode) return;
  try {
    
  jQuery(function() {
    jQuery('.banners-carousel').slick({
      slidesToScroll: 1,
      rows: 0,
      prevArrow: '<button class="slick-prev">Previous</button>',
      nextArrow: '<button class="slick-next">Next</button>',
      infinite: false,
      autoplay: true
    });
  });

  } catch(e) { console.error(e); }
})();
})();
